import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-ag-dropdown",
  templateUrl: "./ag-dropdown.component.html",
  styleUrls: ["./ag-dropdown.component.scss"],
})
export class AgDropdownComponent implements OnInit, ICellRendererAngularComp {
  active: boolean = false;
  selectedStatus : string = ''
  @ViewChild("mySelect", { static: true }) mySelect: ElementRef;
  selectlist: any[] = ["Ready", "Not Ready"];
  constructor() {}
  refresh(params: ICellRendererParams<any, any>): boolean {
    throw new Error("Method not implemented.");
  }
  ngOnInit(): void {}
  agInit(params: ICellRendererParams) {
    this.selectedStatus = params?.data?.lineStatus
  }
  @HostListener("document:click", ["$event.target"])
  onClickOutside(target: HTMLElement) {
    if (!this.mySelect.nativeElement.contains(target)) {
      this.active = false;
    }
  }
}
